export async function generateUploadAdminPassword(): Promise<string> {
  const _sodium = await import('libsodium-wrappers').then(async (mod: any) => {
    const s = (mod as any).default ?? mod;
    await (s as any).ready;
    return s;
  });
  
  // Generate a 32-byte (256-bit) random password
  const randomBytes = _sodium.randombytes_buf(32);

  // Convert to base64 for safe transmission
  return btoa(String.fromCharCode(...randomBytes));
}
